.container {
    min-height: 88px;
}
